import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [RouterModule],
  template: `
    <div class="auth-wrapper">
      <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
        <div class="container">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .auth-wrapper {
      min-height: 100vh;
      background: linear-gradient(-45deg, #5a9cff, #9b7ad9, #e878a8, #ffab5e);
      background-size: 400% 400%;
      animation: gradientShift 15s ease infinite;
      position: relative;
    }
    @keyframes gradientShift {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
    .auth-wrapper::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background:
        radial-gradient(circle at 20% 80%, rgba(90, 156, 255, 0.15) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 171, 94, 0.15) 0%, transparent 50%);
      pointer-events: none;
    }
    .account-pages {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      min-height: 100vh;
    }
  `],
})
export class AuthLayoutComponent {}
